export default "__VITE_ASSET__041e5037__"